import { Button } from 'avo-ui'
import Search from 'components/commons/search'
import PageLimit from 'components/commons/page-limit'
import icLinkExternal from 'assets/images/ic-link-external.svg'
import Table from 'components/commons/table'
import { TABLE_CATEGORY } from 'configs/product/configTableCategory'
import ModalExport from 'components/commons/modal-export'
import ModalDelete from 'components/commons/modal-delete'
import icTrash from 'assets/images/ic-trash.svg'
import { ACTION_TYPE } from 'constants/constant'
import { FormCategory } from 'components/product/category/FormCategory'
import icAddSquare from 'assets/images/ic-add-square.svg'

export const Category = ({
    dataList,
    categoryDetail,
    modal,
    setShowModal,
    query,
    onChangeQuery,
    selectedIds,
    onSubmit,
    onDelete,
    onExport,
    onSelectItemHandler,
    onActionRow,
    onHideForm,
    onChangeForm,
    onSearchParent,
    parentOptions,
    errorForm,
    isLoading,
    isDeleting,
    isExporting,
    isCreating,
    isUpdating,
    isResetSelectedItem,
}) => {
    return (
        <div className={'flex flex-col px-9 py-4'}>
            <div className={'flex gap-3 flex-wrap justify-between'}>
                <div className={'flex space-x-3'}>
                    <Search value={query?.search} onSearch={(key) => onChangeQuery({ search: key, page: 1 })} />
                    <PageLimit value={query?.limit} onSelect={(value) => onChangeQuery({ page: 1, limit: value })} />
                    <Button
                        type={'outline'}
                        title={'Delete'}
                        icon={icTrash}
                        disabled={!selectedIds?.length}
                        onClick={() => onActionRow({ actionType: ACTION_TYPE.DELETE })}
                    />
                    <Button
                        title={'Export'}
                        icon={icLinkExternal}
                        type={'outline'}
                        disabled={!dataList?.total_result}
                        onClick={() => setShowModal({ export: true })}
                    />
                </div>
                <Button
                    type={'outline'}
                    icon={icAddSquare}
                    title={'Create Category'}
                    onClick={() => onActionRow({ actionType: ACTION_TYPE.CREATE })}
                />
            </div>
            <Table
                className={'my-3'}
                name={TABLE_CATEGORY.name}
                columns={TABLE_CATEGORY.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onSelectItem={(val) => onSelectItemHandler(val)}
                onClickItem={onActionRow}
                onChangePage={(val) => onChangeQuery({ page: val })}
                loading={isLoading}
                isResetSelectedItem={isResetSelectedItem}
            />
            {modal?.export && (
                <ModalExport
                    show={modal?.export}
                    onHide={() => setShowModal({ export: false })}
                    description={'Are You Sure Export This?'}
                    totalData={selectedIds?.length || dataList?.total_result}
                    isLoading={isExporting}
                    onExport={onExport}
                />
            )}
            {modal?.delete && (
                <ModalDelete
                    show={modal?.delete}
                    onHide={() => setShowModal({ delete: false })}
                    description={'Are You Sure to Delete Category'}
                    totalData={selectedIds?.length}
                    isLoading={isDeleting}
                    onDelete={onDelete}
                />
            )}
            {modal?.form && (
                <FormCategory
                    show={modal?.form}
                    onHideForm={onHideForm}
                    dataCategory={categoryDetail}
                    options={parentOptions}
                    onSearchOptions={onSearchParent}
                    isLoading={isCreating || isUpdating}
                    onChangeForm={onChangeForm}
                    errorForm={errorForm}
                    onSubmit={onSubmit}
                />
            )}
        </div>
    )
}
